import * as React from "react";
import { SVGProps } from "react";

const Moac = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}>
    <circle cx={100} cy={100} r={100} />
    <g fill="#fff">
      <path d="M177.53 110.72a15.39 15.39 0 0 1-21.53 3.15 15.39 15.39 0 0 1-3.15-21.53 15.39 15.39 0 0 1 21.53-3.15 15.39 15.39 0 0 1 3.15 3.15l4.33-3.1a20.75 20.75 0 0 0-29-4.43 20.75 20.75 0 0 0-4.43 29 20.75 20.75 0 0 0 29 4.43 20.75 20.75 0 0 0 4.43-4.43Zm-51.91-33.09-3 6.24-17.79 38.39h5.8l4.11-8.89h21.64l4.12 8.89h5.83l-17.8-38.39Zm-8.35 30.46 8.35-18 8.33 18h-16.68Zm-78.03-6.52L24.25 86.58l-.41-.41-5.31-5.32v41.4h5.31V93.7l11.64 11.64 3.76 3.76 3.75-3.76L54.63 93.7v28.55h5.31V80.86l-5.31 5.31-15.39 15.4zm46.71-20.71a20.75 20.75 0 0 0-20.75 20.75 20.75 20.75 0 0 0 20.75 20.75 20.75 20.75 0 0 0 20.75-20.75 20.75 20.75 0 0 0-20.75-20.75Zm0 36.1a15.4 15.4 0 0 1-15.42-15.39 15.4 15.4 0 0 1 15.39-15.42 15.4 15.4 0 0 1 15.41 15.39A15.4 15.4 0 0 1 85.95 117Z" />
      <circle cx={94.72} cy={92.77} r={1.44} />
      <circle cx={94.72} cy={110.3} r={1.44} />
      <circle cx={77.18} cy={92.77} r={1.44} />
      <circle cx={73.53} cy={101.54} r={0.73} />
      <circle cx={85.95} cy={113.98} r={0.73} />
      <circle cx={98.36} cy={101.54} r={0.73} />
      <circle cx={85.95} cy={89.15} r={0.73} />
      <circle cx={85.95} cy={92.77} r={0.73} />
      <circle cx={77.18} cy={110.3} r={1.44} />
      <circle cx={85.95} cy={110.3} r={1.44} />
      <path d="M94.45 92.77h.53v17.54h-.53zm-17.27 0h17.54" />
      <path d="M77.18 92.68h17.54v.18H77.18z" />
      <path d="m85.894 92.812.161-.08 8.755 17.535-.161.08z" />
      <path d="m77.112 110.265 8.772-17.539.16.081-8.77 17.539z" />
      <path d="M76.91 92.77h.53v17.54h-.53zm17.81 17.53H77.18" />
      <path d="M77.18 110.21h17.54v.18H77.18z" />
      <path d="m76.955 92.896.474-.237 8.771 17.539-.474.237z" />
      <path d="m85.718 110.19 8.772-17.539.474.238-8.772 17.539zm-12.263-8.667 3.634-8.778.167.07-3.634 8.777z" />
      <path d="m77.1 110.35-3.64-8.76.16-.08 3.65 8.76-.17.08zm8.76-.05h.18v3.66h-.18zm0-21.18h.18v3.66h-.18z" />
      <path d="m77.157 92.686 8.769-3.63.069.166-8.769 3.63z" />
      <path d="m85.905 89.228.07-.166 8.777 3.634-.07.166z" />
      <path d="m94.64 92.803.165-.069 3.637 8.776-.166.07z" />
      <path d="m94.627 110.308 3.642-8.796.166.069-3.641 8.796z" />
      <path d="m85.903 113.904 8.798-3.662.069.166-8.798 3.663z" />
      <path d="m85.91 114.05-8.79-3.66.06-.16 8.8 3.66-.07.16z" />
    </g>
  </svg>
);

export default Moac;
